import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "launcher-token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const fetchUsers = () => api.get("/auth/users").then((r) => r.data);
export const createUser = (data) => api.post("/auth/users", data).then((r) => r.data);
export const deleteUser = (id) => api.delete(`/auth/users/${id}`).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);

// Apps
export const fetchApps = () => api.get("/apps").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const createApp = (data) => api.post("/apps", data).then((r) => r.data);
export const updateApp = (id, data) => api.put(`/apps/${id}`, data).then((r) => r.data);
export const toggleFavorite = (id) => api.patch(`/apps/${id}/favorite`).then((r) => r.data);
export const deleteApp = (id) => api.delete(`/apps/${id}`).then((r) => r.data);
export const reorderApps = (orderedIds) => api.put("/apps/reorder", { ordered_ids: orderedIds }).then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
